import Stats from './stats';
import User from './user';
import Department from './depart';
import Desktop from './desktop';
import Screenshot from './screenshot';
import Warn from './warn';
import Dashboard from './dashboard';
export interface IMobxState {
  dashboard: Dashboard;
  stats: Stats;
  user: User;
  department: Department;
  desktop: Desktop;
  screenshot: Screenshot;
  warn: Warn;
}

const monitor = {
  dashboard: new Dashboard(),
  stats: new Stats(),
  user: new User(),
  department: new Department(),
  desktop: new Desktop(),
  screenshot: new Screenshot(),
  warn: new Warn()
};
export default monitor;
